import { isEmpty, isNil } from 'lodash-es'
import { useFormContext } from 'react-hook-form'

import { Icon, Message } from '@/shared/ui'

export const ErrorMessage = () => {
  const {
    formState: { errors },
  } = useFormContext()

  const message = (() => {
    if (isEmpty(errors)) {
      return null
    }

    if (errors.root?.accountError) {
      return errors.root.accountError.message as string
    }

    if (errors.root?.accountServerError) {
      return errors.root.accountServerError.message as string
    }

    if (errors.bankName?.message) {
      return errors.bankName.message as string
    }

    if (errors.bankAccount?.message) {
      return errors.bankAccount.message as string
    }
  })()

  if (isNil(message)) {
    return null
  }

  return (
    <Message type="error" className="flex">
      <Icon name="alert-filled" size={20} className="relative -top-0.5" />
      {message}
    </Message>
  )
}
